import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { SubscriptionService } from '../../services/subscription.service';

@Component({
    selector: 'app-foruplus-terms',
    templateUrl: './foruplus-terms.component.html',
    styleUrls: ['./foruplus-terms.component.scss']
})
export class ForuplusTermsComponent implements OnInit, OnDestroy {
    currentEnvironment;
    termsContent = '';
    showTermsContent = false;
    private destroy$ = new Subject<void>();

    constructor(
        public subscriptionService: SubscriptionService,
        private titleService: Title) {
        this.titleService.setTitle('forU+ - Terms and Conditions');
    }

    ngOnInit(): void {
        this.currentEnvironment = this.subscriptionService.getEnvironment();
        this.subscriptionService.getB4UPlusTermsComponent(this.currentEnvironment)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => { this.termsContent = data || ''; this.showTermsContent = !!data; },
                error: () => { this.termsContent = ''; this.showTermsContent = false; }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
